import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
import { Helmet } from "react-helmet";
import PermProduct from "./PermProduct"
import TermData from '../Common/data/products/term/TermData';
import AssetBasedHybridLtcData from '../Common/data/products/asset-based-ltc/AssetBasedHybridLtcData';
import TraditionalLtcData from '../Common/data/products/traditional-long-term-care/TraditionalLtcData';
import DisabilityInsuranceData from '../Common/data/products/disability-insurance/DisabilityInsuranceData';
import SvgIcon from '@material-ui/core/SvgIcon';
import Calculator from '../../icons/calculator.svg';
import Card from '@material-ui/core/Card';
import ProductHeader from "../Common/ProductHeader/ProductHeader";
import './Product.scss';
import { ILLUSTRATION_PREFILL_DATA } from "../../sessionStorage";

export default function ProductLandingPage(props) {

  var data;

  switch (props.match.params.product) {
    case "Term":
      data = TermData();
      break;
    case "perm-insurance":
      data = "permproductvisible";
      break;
    case "ABLTC":
      data = AssetBasedHybridLtcData();
      break;
    case "traditional-long-term-care":
      data = TraditionalLtcData();
      break;
    case "disability-insurance":
      data = DisabilityInsuranceData();
      break;
    default:
      window.location = "/not-found"
  }

  const [prodcuName,setProductName] = useState();

  useEffect(() => {
    if(ILLUSTRATION_PREFILL_DATA)
      sessionStorage.removeItem(ILLUSTRATION_PREFILL_DATA);

    const product = props.match.params.product;
    if (product === "Term") {
      setProductName('term-insurance')
    } else if (product === 'ABLTC'){
      setProductName('asset-based-hybrid-ltc')
    } else {
      setProductName(product)
    }
    window.scrollTo(0,0);
  },[]);

  return (
    <div>
    { data ==='permproductvisible' ? <PermProduct/> :
    <Container fluid className="product-landing">
      <Helmet>
        <title>Covr Advisor - {data.name}</title>
      </Helmet>
      <ProductHeader data={data} permission={props.permission}/>
      <Container fluid className={'landing-content-container'}>
        <Row className="mt-4">
          <Col md={8} className="pr-5">
            <AboutData data={data.about} />
            <InsuranceTools data={data.insuranceTools} />
            <WatchVideo data={data.video} />
            <HowDoesItWork data={data.howDoesItWorkData} />
            <HowIsItUsed data={data.HowIsItUsedData} />
            <WhoIsThisProductFor data={data.WhoIsThisProductData} />
            <HowToPurchase data={data.howToPurchase}></HowToPurchase>
          </Col>
          <Col md={4}>
            <KeyFeatures data={data.productSpecifications} coverageAmount={data.specs.coverageAmount} />
          </Col>
        </Row>
      </Container>

    </Container>
    }
    </div>
  )
}

function AboutData(props) {
  const { data } = props;

  return (
    <Container className="pl-0">
      <Row id="about" className="mb-4">
        <div>
          <div className="mb-3 product-title">{data.title}</div>
          <div className="product-content">
            {data.content}
          </div>
          {data.didYouKnow &&
          <Container>
          <br />
          <Row className="did-you-know product-content">
            <Col lg={11}>
              <div className="product-content">
                <b>Did You Know?</b><br />
                {data.didYouKnow}
              </div>
            </Col>
          </Row>
        </Container>}
        </div>
      </Row>
    </Container>
  )
}

function WatchVideo(props) {
  const { data } = props;
  return (
    <React.Fragment>
      {data && (
        <Container className="pl-0 pt-3">
          <Row className="mb-4 pl-0">
            <div className="mb-3 product-title">Watch a Video</div>
            <div className="embed-responsive embed-responsive-16by9">
              <iframe src={data.link} className="embed-responsive-item" title={props.title} />
            </div>
            <div className="video-description-header mt-2">{data.description}</div>
            <div className="product-content">{data.content}</div>
          </Row>
        </Container>
      )}
    </React.Fragment>

  )
}

function HowDoesItWork(props) {
  const { data } = props;
  
  let element = document.getElementById(data.navigateToPurchaseLinkId);
  if (element) {
    element.onclick = function onNavigateToPurchaseClick() {
      data.onNavigateToPurchase()
    }
  }

  return (
    <React.Fragment>
      {data && (
    <Container className="pl-0">
      <Row id="howDoesItWork" className="mb-4">
        <div>
          <div className="mb-3 product-title">{data.title}</div>
          {data.paragraphs.map((v, i) =>
                <div className="product-content" key={i} dangerouslySetInnerHTML={{ __html: v }}></div>
              )}
        </div>
      </Row>
    </Container>
    )}
    </React.Fragment>
  )
}

function HowIsItUsed(props) {
  const { data } = props;

  return (
    <React.Fragment>
      {data && (
    <Container className="pl-0">
      <Row id="howIsItUsed" className="mb-4">
        <div>
          <div className="mb-3 product-title">{data.title}</div>
          {data.paragraphs.map((v, i) =>
                <div className="product-content" key={i} dangerouslySetInnerHTML={{ __html: v }}></div>
              )}
        </div>
      </Row>
    </Container>
    )}
    </React.Fragment>
  )
}

function WhoIsThisProductFor(props){
  const { data } = props;

  return (
    <React.Fragment>
      {data && (
    <Container className="pl-0">
      <Row id="whoIsThisProductFor" className="mb-4">
        <div>
          <div className="mb-3 product-title">{data.title}</div>
          {data.paragraphs.map((v, i) =>
                <div className="product-content" key={i} dangerouslySetInnerHTML={{ __html: v }}></div>
              )}
        </div>
      </Row>
    </Container>
    )}
    </React.Fragment>
  )
}

function HowToPurchase(props) {
  const { data } = props;

  let element = document.getElementById(data.linkId);
  let massMutualElement = document.getElementById(data.massMutualLinkId);
  let navigateToAppointmentElement = document.getElementById(data.navigateToAppointmentLinkId);
  if (element) {
    element.onclick = function clearSession() {
      data.onLinkClick()
    }
  }
  if (massMutualElement) {
    massMutualElement.onclick = function onMassMutualClick() {
      data.onMassMutualLinkClick()
    }
  }
  if (navigateToAppointmentElement) {
    navigateToAppointmentElement.onclick = function onNavigateToAppointmentClick() {
      data.NavigateToAppointmentLinkClick()
    }
  }

  return (
    <React.Fragment>
      {data && (
        <Container className="pl-0">
          <Row id="howToPurchase" className="mb-4">
            <div>
              <div className="mb-3 product-title">{data.title}</div>
              {data.paragraphs.map((v, i) =>
                <div className="product-content" key={i} dangerouslySetInnerHTML={{ __html: v }}></div>
              )}
            </div>
          </Row>
        </Container>
      )}
    </React.Fragment>
  )
}

function InsuranceTools(props) {
  const history = useHistory();
  const { data } = props;

  return (
    <React.Fragment>
      {data && (
        <Container className="pl-0">
          <Row className="mb-4">
            <div>
              <div className="mb-3 product-title">{data.title}</div>
              <div className="products-container ">
                <Row className="w-100">
                  <Col>
                    <Card className="insurance-card needs-analysis" onClick={() => history.push('/InsuranceTools/NeedsAnalysis')}>
                      <div className="d-flex justify-content-center ">
                        <Row className={`d-flex justify-content-center align-items-center`}>
                          <SvgIcon component={Calculator} color='primary' className='icon-common' />
                        </Row>
                      </div>
                      <div className='pt-2'><b>Needs Analysis</b></div>
                    </Card>
                  </Col>
                </Row>
              </div>
            </div>
          </Row>
        </Container>
      )}
    </React.Fragment>
  )
}
function KeyFeatures(props) {
  const { data } = props;

  return (
    <React.Fragment>
    {data && (
      <Row className="product-specifications">
        <Col>
          <div className="mb-3 product-title">Product Specifications</div>
          {data.map((p, i) =>
            <div key={i} className="mb-3">
              <h6 className="mb-1"><strong>{p.title}</strong></h6>
              <div className="product-content" dangerouslySetInnerHTML={{ __html: p.text }}></div>
            </div>
          )}
        </Col>
      </Row>
    )}
    </React.Fragment>
  )
}


// WEBPACK FOOTER //
// ./src/components/ProductLanding/Product.js